import { useApi } from '@axiom/ui';
import type { Account } from '@axiom/validation';

import { CandidateApi } from '../api/candidate-api';

export const useCandidateProfilesData = (account: Account) => {
  const [{ data: savedCandidatesFromEndpoint } = { data: [] }] = useApi(
    CandidateApi.readFavoriteCandidates()
  );

  const savedCandidates = savedCandidatesFromEndpoint.map(c => c.candidate);
  const excludedCandidateIds = savedCandidates.map(c => c.id);

  const filters = {
    excludedCandidateIds,
    ...(account.industryValue && { industries: [account.industryValue] }),
  };

  const [{ data: allCandidates } = { data: [] }] = useApi(
    CandidateApi.readCandidateSearchResults({
      page: 1,
      pageSize: 11,
      filters,
    })
  );

  return {
    savedCandidates,
    allCandidates,
  };
};
